import { render } from "./Picking.vue?vue&type=template&id=a90a6c22&scoped=true"
import script from "./Picking.vue?vue&type=script&lang=js"
export * from "./Picking.vue?vue&type=script&lang=js"

import "./Picking.vue?vue&type=style&index=0&id=a90a6c22&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90a6c22"]])

export default __exports__